import React, { Component } from 'react';
import Tree from 'react-vertical-tree';
import {
  fetchHirarchyDetails,
  HirarchyDataSelector,
  session,
} from '../../Service/APIService';
import WidgetOptions from './../Custom/WidgetOptions';

class TreeView extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      preSelected: {},
      loading: true,
    };
  }

  async componentDidMount() {
    const sessionId = session.client();
    const childrens = await this.fetchHirarchy('client', sessionId);
    const data = [
      {
        id: 1,
        name: 'Client',
        parent: null,
        type: 'client',
        children: childrens,
      },
    ];
    this.setState({
      data,
      loading: false,
    });
  }

  fetchHirarchy = (type, id) => {
    return fetchHirarchyDetails(type, id)
      .then((res) => {
        return HirarchyDataSelector(type, res.data.result).map((item) => ({
          id: item.id,
          parent: { id: item.parentId },
          name: item.name,
          type: item.nodeType,
          children: [],
        }));
      })
      .catch((err) => {
        console.log('Error', err);
        return [];
      });
  };

  onNodeClick = async (item) => {
    const { id, type } = item;
    const childrens = await this.fetchHirarchy(type, id);

    let data = JSON.parse(JSON.stringify(this.state.data));
    this.updateHirarchy(data, item, childrens);
    this.setState({ data, preSelected: item });
    if (childrens.length === 0) {
      alert('no child nodes exist');
    }
  };

  updateHirarchy = (data, item, childrens) => {
    // eslint-disable-next-line
        data.map((x) => {
      if (x.id === item.id && x.type === item.type) {
        x.children = childrens;
      } else {
        if (x.type === item.type) {
          x.children = [];
        } else {
          this.updateHirarchy(x.children, item, childrens);
        }
      }
    });
  };

  render() {
    return this.state.loading ? (
      <span>loading...</span>
    ) : (
      <div>
        <div className="pull-right" style={{ marginRight: '10px' }}>
          <WidgetOptions
            infoIdText={'hierarchy'}
            expandIdText={'MAP'}
            onExpandClick={() => this.onExpandClick.bind(this)}
            hideExpand={true}
          ></WidgetOptions>
          {/* <CustomTooltip id="help" tooltip={'help'} placement={'bottom'}>
                            <button type="button"
                                className="btn btn-box-tool"
                                data-widget="collapse"
                                onClick={() => props.onInfoClick(props.infoIdText)}>
                                <i className="fa fa-info-circle"></i>
                            </button>
                        </CustomTooltip>


                        <CustomTooltip id="full screen" tooltip={'full screen'} placement={'bottom'}>
                            <button type="button" className="btn btn-box-tool" data-widget="remove"
                                onClick={() => props.onFullscreenClick(props.expandIdText)}>
                                <i className="fa fa-expand"></i></button>
                        </CustomTooltip> */}
        </div>
        <div
          style={{
            justifyContent: 'center',
            display: 'flex',
            marginTop: '20px',
            marginBottom: '60px',
          }}
        >
          {<Tree data={this.state.data} direction onClick={this.onNodeClick} />}
        </div>
      </div>
    );
  }
}

export default TreeView;
